import React from 'react'
import Header from '../components/Header'
import Contact from '../components/Contact'

function Home() {
    return (
        <main class="page-content">
            <div class="hero-banner style-1" style={{backgroundImage: 'url(images/hero-banner/bg1.webp)', backgroundSize: 'cover'}}>
                <div class="container">
                    <div class="inner-wrapper">
                        <div class="row align-items-end h-100">
                            <div class="col-lg-6 align-self-center">
                                <div class="hero-content">
                                    <h1 class="title wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s">Estrategias a tu medida en <span class="text-primary">Consultoría</span> y Contact Center <img src="images/hero-banner/line.png" alt=""/></h1>
                                    <p class="text wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="0.8s">Impulsamos el crecimiento de tu empresa con soluciones legales, financieras y de atención al cliente. </p>
                                    <a href="/contact-center-soluciones-inteligentes" class="btn btn-lg btn-icon btn-primary m-r20 wow fadeInUp" data-wow-delay="0.6s" data-wow-duration="0.8s">
                                        Contact Center
                                        <span class="right-icon"><i class="feather icon-arrow-right"></i></span>
                                    </a>
                                    <a href="/contacto" class="btn btn-lg btn-icon btn-secondary wow fadeInUp" data-wow-delay="0.6s" data-wow-duration="0.8s">
                                        Contactanos
                                        <span class="right-icon"><i class="feather icon-arrow-right"></i></span>
                                    </a>
                                </div>
                            </div>
                            <div class="col-lg-6 wow fadeInRight" data-wow-delay="0.8s" data-wow-duration="0.8s">
                                <div class="hero-thumbnail" data-bottom-top="transform: translateY(-50px)" data-top-bottom="transform: translateY(50px)">
                                    <img class="thumbnail" src="images/hero-banner/hero-1.svg" alt=""/>
                                    <div class="circle-wrapper">
                                        <span class="circle1"></span>
                                        <span class="circle2"></span>
                                        <span class="circle3"></span>
                                        
                                        <div class="item1">
                                            <img src="images/hero-banner/heart.png" alt=""/>
                                        </div>
                                    </div>
                                   
                                </div>
                            </div>
                        </div>
                        <div class="item5" data-bottom-top="transform: translateY(-30px)" data-top-bottom="transform: translateY(30px)">
                            <div class="info-widget style-4 move-4">
                                <div class="widget-content">
                                    <h6 class="title">¿Tienes una pregunta?</h6>
                                    <a href="mailto:contacto@conectaycrece.com.mx">contacto@conectaycrece.com.mx</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <section class="content-inner mt-10">
                <div class="container">
                    <div class="row content-wrapper style-3">
                        <div class="col-xl-5 m-b30 pe-xl-5">
                            <div class="section-head style-1 m-b30">
                                <h2 class="title m-b0 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s">Consultoría legal, fiscal y financiera</h2>
                                <p class="wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="0.8s">
                                    Nuestro equipo multidisciplinario ofrece asesoría integral para personas, empresas e inversionistas. Desde estrategias fiscales hasta estructuración de financiamientos, te ayudamos a tomar decisiones sólidas, legales y rentables.
                                </p>
                            </div>
                            <div class="row">
                                <div class="col-xl-12 col-md-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s">
                                    <div class="icon-bx-wraper style-2 m-b20">
                                        <div class="icon-bx">
                                            <span class="icon-cell">
                                                <i class="feather icon-clock"></i>
                                            </span>
                                        </div>
                                        <div class="icon-content">
                                            <h3 class="dz-title">Asesoría en financiamientos</h3>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-12 col-md-6 wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="0.8s">
                                    <div class="icon-bx-wraper style-2 m-b20">
                                        <div class="icon-bx">
                                            <span class="icon-cell">
                                                <i class="flaticon-list"></i>
                                            </span>
                                        </div>
                                        <div class="icon-content">
                                            <h3 class="dz-title">Evaluación de portafolios de inversión</h3>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-12 col-md-6 wow fadeInUp" data-wow-delay="0.6s" data-wow-duration="0.8s">
                                    <div class="icon-bx-wraper style-2 m-b20">
                                        <div class="icon-bx">
                                            <span class="icon-cell">
                                                <i class="flaticon-stethoscope"></i>
                                            </span>
                                        </div>
                                        <div class="icon-content">
                                            <h3 class="dz-title">Consultoría legal <br/> (civil, mercantil, familiar, fiscal)</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-7">
                            <div class="content-media">
                                <div class="dz-media">
                                    <img src="images/about/img-1.png" alt="" />
                                    
                                    <div class="dz-btn">
                                        <a href="/consultoría-integral" class="btn btn-lg btn-icon btn-secondary btn-shadow">
                                            Descubre más sobre Consultoría <span class="right-icon"><i class="feather icon-arrow-right"></i></span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="content-inner-2 mt-10">
                <div class="container">
                    <div class="row g-3 g-lg-4 align-items-center">
                        <div class="col-lg-7">
                            <div class="dz-media radius-lg height-sm ms-xl-4 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s">
                                <img src="images/about/img-2.png" alt="" class="object-fit-cover"/>
                            </div>
                        </div>
                        <div class="col-lg-5">
                            <div class="section-head style-1 mb-0">
                                <h2 class="title wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s">Contact Center </h2>
                                <h3 class="font-24 text-primary m-b20 wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="0.8s">Para una atención al cliente de alto nivel</h3>
                                <p class="wow fadeInUp" data-wow-delay="0.6s" data-wow-duration="0.8s">
                                    Brindamos soluciones de atención multicanal para mejorar la experiencia de tus usuarios y optimizar tus procesos internos. Externaliza tus servicios y concéntrate en lo que mejor sabes hacer.
                                    <br/><br/>
                                    <ul>
                                        <li>📍 Cobranza personalizada</li>
                                        <li>📍 Atención al cliente y soporte técnico</li>
                                        <li>📍 Encuestas, help desk y monitoreo telefónico</li>
                                        <li>📍 Ventas y seguimiento comercial</li>
                                    </ul>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="content-inner" style={{backgroundImage: 'url(images/background/bg3.png)',    backgroundposition: 'right bottom', backgroundrepeat: 'no-repeat'}}>
                <div class="container">
                    <div class="row content-wrapper style-5">
                        <div class="col-xxl-12 col-xl-12 col-lg-12 m-b30 align-self-center">
                            <div class="content-info">
                                <div class="section-head style-1 m-b30">
                                    <h2 class="title wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.7s">¿Por qué elegirnos? </h2>
                                    
                                </div>
                                <div class="accordion dz-accordion style-1" id="accordionExample">
                                    <div class="accordion-item wow fadeInUp" data-wow-delay="0.5s" data-wow-duration="0.7s">
                                        <h2 class="accordion-header">
                                            <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                Experiencia comprobada
                                            </button>
                                        </h2>
                                        <div id="collapseOne" class="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                                            <div class="accordion-body">
                                                <p>Más de 10 años asesorando empresas en áreas legales, fiscales y de atención. Hemos trabajado con empresas de todos los tamaños, ayudándolas a resolver problemas complejos, cumplir con normativas y optimizar sus procesos internos. Nuestra trayectoria nos permite anticipar escenarios y ofrecer soluciones estratégicas desde la experiencia real.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-item wow fadeInUp" data-wow-delay="0.6s" data-wow-duration="0.7s">
                                        <h2 class="accordion-header">
                                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                                Atención cercana y profesional
                                            </button>
                                        </h2>
                                        <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                            <div class="accordion-body">
                                                <p>Creemos en relaciones a largo plazo. Nuestro equipo combina trato empático con conocimientos técnicos actualizados. Asignamos asesores dedicados que te guían desde la primera reunión hasta la implementación y seguimiento de resultados. Cada consulta es atendida con compromiso, ética y confidencialidad.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-item wow fadeInUp" data-wow-delay="0.7s" data-wow-duration="0.7s">
                                        <h2 class="accordion-header">
                                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                                Soluciones a la medida
                                            </button>
                                        </h2>
                                        <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                            <div class="accordion-body">
                                                <p>No trabajamos con modelos genéricos. Cada cliente recibe una solución diseñada de acuerdo con su sector, presupuesto y objetivos. Ya sea que necesites reestructurar tu deuda, mejorar tus canales de atención o resolver temas legales específicos, construimos un plan a la medida que garantice resultados efectivos.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-item wow fadeInUp" data-wow-delay="0.8s" data-wow-duration="0.7s">
                                        <h2 class="accordion-header">
                                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                                Herramientas avanzadas
                                            </button>
                                        </h2>
                                        <div id="collapseFour" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                            <div class="accordion-body">
                                                <p>Integramos tecnología para agilizar procesos, mejorar la comunicación y asegurar la trazabilidad de cada acción. Desde CRMs de atención al cliente hasta herramientas de gestión documental, seleccionamos el stack tecnológico adecuado para que cada proyecto tenga soporte digital de calidad.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Contact/>
        </main>
    )
}

export default Home